export interface ServiceHistoryId { __serviceHistoryId: number}

export default class ServiceHistory {
  id: ServiceHistoryId | null = null;
  date = '';
  mileage: number | null = null;
  code = '';
  description = '';
}
